import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { API } from "src/util/api";
import { NotificationTypes } from "./actionTypes";
import { closeAllNotificationError, closeAllNotificationSuccess, closeNotificationError, closeNotificationSuccess, getNotificationByIdError, getNotificationByIdSuccess, getNotificationConfigError, getNotificationConfigSuccess, getNotificationCountError, getNotificationCountSuccess, getNotificationError, getNotificationListError, getNotificationListSuccess, getNotificationStatusError, getNotificationStatusSuccess, getNotificationSuccess, postNotificationConfigError, postNotificationConfigSuccess } from "./action";

function* getNotificationListAsync(action : any) {

    try {
      const response : Promise<any> = yield call(
          API.getNotificationListAPI,{...action.lazyState}
      )
      yield put(getNotificationListSuccess(response));
    } catch (error) {
      yield put(getNotificationListError(error));
    }
  }
function* getNotificationCountAsync(action : any) {

    try {
      const response : Promise<any> = yield call(
          API.getNotificationCountAPI
      )
      yield put(getNotificationCountSuccess(response));
    } catch (error) {
      yield put(getNotificationCountError(error));
    }
  }

  
function* getNotificationByIdAsync(action:any) {
  try {
    const response : Promise<any> = yield call(API.getNotificationByIdApi,action.id);    
    yield put(getNotificationByIdSuccess(response));

  } catch (error) {
    yield put(getNotificationByIdError(error));
  }
}

function* getNotificationStatusAsync() {
  try {
    const response : Promise<any> = yield call(API.getBulkEmailStatusApi);    
    yield put(getNotificationStatusSuccess(response));

  } catch (error) {
    yield put(getNotificationStatusError(error));
  }
}

function* getNotificationAsync() {
  try {
    const response : Promise<any> = yield call(API.getNotificationApi);    
    yield put(getNotificationSuccess(response));

  } catch (error) {
    yield put(getNotificationError(error));
  }
}

function* closeNotificationAsync(action:any) {
  try {
    const response : Promise<any> = yield call(API.closeNotificationApi,action.payload);    
    yield put(closeNotificationSuccess(response));

  } catch (error) {
    yield put(closeNotificationError(error));
  }
}

function* closeAllNotificationAsync(action:any) {
  try {
    const response : Promise<any> = yield call(API.closeAllNotificationApi);    
    yield put(closeAllNotificationSuccess(response));

  } catch (error) {
    yield put(closeAllNotificationError(error));
  }

}

function* getNotificationConfigAsync(action:any) {
  try {
    const response : Promise<any> = yield call(API.getNotificationConfigApi);    
    yield put(getNotificationConfigSuccess(response));

  } catch (error) {
    yield put(getNotificationConfigError(error));
  }
}

function* postNotificationConfigAsync(action:any) {
  try {
    const response : Promise<any> = yield call(API.postNotificationConfigApi,action.payload);    
    yield put(postNotificationConfigSuccess(response));

  } catch (error) {
    yield put(postNotificationConfigError(error));
  }
}

  function* NotificationSaga() {
    yield takeLatest(NotificationTypes.GET_NOTIFICATION_LIST_LOADING, getNotificationListAsync);
    yield takeLatest(NotificationTypes.GET_NOTIFICATION_COUNT_LOADING, getNotificationCountAsync);
    yield takeEvery(NotificationTypes.GET_BY_ID_NOTIFICATION_LOADING, getNotificationByIdAsync);
    yield takeEvery(NotificationTypes.GET_NOTIFICATION_STATUS_LOADING, getNotificationStatusAsync);
    yield takeEvery(NotificationTypes.GET_NOTIFICATION_LOADING, getNotificationAsync);
    yield takeEvery(NotificationTypes.CLOSE_NOTIFICATION_LOADING, closeNotificationAsync);
    yield takeEvery(NotificationTypes.CLOSE_ALL_NOTIFICATION_LOADING, closeAllNotificationAsync);
    yield takeEvery(NotificationTypes.GET_NOTIFICATION_CONFIG_LOADING, getNotificationConfigAsync);
    yield takeEvery(NotificationTypes.POST_NOTIFICATION_CONFIG_LOADING, postNotificationConfigAsync);
  }
  
  export default NotificationSaga;